import KeyProxy from '@/proxies/Key';
import KeyTransform from '@/transforms/Key';
import * as types from './mutation-types';

export default {
  async items({ commit, dispatch }) {
    commit(types.LOADING, true);
    const proxy = new KeyProxy();
    try {
      const response = await proxy.load();
      commit(types.SET, KeyTransform.fetchCollection(response.keys));
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_keys', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },
  async deleteKey({ commit, dispatch }, payload) {
    const proxy = new KeyProxy();
    try {
      await proxy.delete(payload);
      commit(types.DELETE, payload);
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_delete_key', { root: true });
    }
  },
  async disableKey({ commit, dispatch }, payload) {
    const proxy = new KeyProxy();
    try {
      const response = await proxy.update(payload, { is_active: false });
      commit(types.UPDATE, KeyTransform.fetch(response.key));
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_update_key', { root: true });
    }
  },
  async enableKey({ commit, dispatch }, payload) {
    const proxy = new KeyProxy();
    try {
      const response = await proxy.update(payload, { is_active: true });
      commit(types.UPDATE, KeyTransform.fetch(response.key));
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_update_key', { root: true });
    }
  },
  async createKey({ commit, dispatch }, payload) {
    const proxy = new KeyProxy();
    try {
      const response = await proxy.create(payload);
      commit(types.CREATE, KeyTransform.fetch(response.key));
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_create_key', { root: true });
    }
  },
  createComplete({ commit, getters }) {
    const key = getters.newKey;
    if (key) {
      commit(types.ADD, key);
    }
    commit(types.COMPLETE);
  },
};
